import { useRouter } from 'next/router'
import { useEffect, useMemo, useState } from 'react'
import { extractQueryParams } from 'services/url'
import { useIsPrerendering } from './utility'

export function useQueryParams() {
  const router = useRouter()
  return useMemo(() => extractQueryParams(router?.asPath), [router?.asPath])
}

export function useLocationPathname() {
  const router = useRouter()
  return router.pathname
}

export function useAnchor(): string | null {
  const [anchor, setAnchor] = useState<string | null>(null)
  const isPrerendering = useIsPrerendering()

  useEffect(() => {
    if (!isPrerendering) {
      setAnchor(window.location.hash?.slice(1) || null)
    }
  }, [isPrerendering])

  return anchor
}
